import Vue from 'vue';
import VueMq from 'vue-mq';
import App from './App.vue';
import router from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'jquery/dist/jquery.slim.js';
import 'popper.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './plugins/customScroll';


Vue.config.productionTip = false;

console.log('Torbel Site v2026.02.17 - Bust Cache 2');

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 768,
    desktop: Infinity
  },
  defaultBreakpoint: 'desktop'
})

new Vue({
  created () {
    AOS.init()
  },
  router,
  render: h => h(App)
}).$mount('#app')